import { render, staticRenderFns } from "./fallback-card.vue?vue&type=template&id=9a981518&scoped=true&"
import script from "./fallback-card.vue?vue&type=script&lang=js&"
export * from "./fallback-card.vue?vue&type=script&lang=js&"
import style0 from "./fallback-card.vue?vue&type=style&index=0&id=9a981518&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a981518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a981518')) {
      api.createRecord('9a981518', component.options)
    } else {
      api.reload('9a981518', component.options)
    }
    module.hot.accept("./fallback-card.vue?vue&type=template&id=9a981518&scoped=true&", function () {
      api.rerender('9a981518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/ui-registry/fallback-card.vue"
export default component.exports